/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_NoteInputs */

const en_history_note = /** @type {(inputs: History_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const de_history_note = /** @type {(inputs: History_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {History_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_note = /** @type {((inputs?: History_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_note(inputs)
	return en_history_note(inputs)
});